import React, { useCallback, useEffect, useState } from "react";
import { initUserInformationAction, registerUserInformationAction } from "../../../../state/usecase/admin/user/actions";
import { getCareRecipientListAction } from "../../../../state/usecase/admin/care_recipient/actions";
import { State, useAppDispatch } from "../../../../state/store";
import { UserName } from "../../../../domain/user/UserName";
import { getUserAccountRoleFromValue } from "../../../../domain/user/account/UserAccountRole";
import { CareRecipientId } from "../../../../domain/care_recipient/CareRecipientId";
import { UserEmail } from "../../../../domain/user/UserEmail";
import { Loading } from "../../common/Loading";
import { UserInfoEditComponent } from "./UserInfoEditComponent";
import { BackButton } from "../../common/button/BackButton";
import { useCareRecipientList } from "../../../hooks/admin/care_recipient/useCareRecipientList";
import { UserEditType } from "../../../../domain/user/User";
import { UserPassword } from "../../../../domain/user/UserPassword";
import { useSelector } from "react-redux";
import { Paths } from "../../../../Paths";
import { FullScreenLoading } from "../../common/FullScreenLoading";
import { useNavigate } from "react-router-dom";

export function AdminUserAddPage() {
    const dispatch = useAppDispatch();

    const careRecipientList = useCareRecipientList();

    const navigate = useNavigate();

    const onRegisterSuccess = useCallback(() => navigate(`${Paths.admin}${Paths.user}${Paths.list}`), [history]);

    const hasError = useSelector((state: State) => state.adminUser.userInformationRegisterFailed);

    const processing = useSelector((state: State) => state.adminUser.processing) > 0;

    const [errorCode, setErrorCode] = useState("");

    const handleErrorCode = useCallback((errorCode: string) => setErrorCode(errorCode), []);

    useEffect(() => {
        dispatch(initUserInformationAction());
        dispatch(getCareRecipientListAction());

        return () => {
            dispatch(initUserInformationAction());
        };
    }, [dispatch]);

    useEffect(() => {
        if (hasError) {
            const message = errorCode === "CONFLICT" ? "メールアドレスが登録済みです" : "登録に失敗しました";
            alert(message);
        }
    });

    const handleRegisterClicked = useCallback((name: string, email: string, password: string, role: string, careRecipients: string[], sendEmail: boolean = false) => {
        dispatch(
            registerUserInformationAction({
                userName: UserName.fromString(name),
                userEmail: UserEmail.fromString(email),
                userPassword: UserPassword.fromString(password),
                role: getUserAccountRoleFromValue(role),
                viewableCareRecipients: careRecipients.map((careRecipient) => CareRecipientId.fromString(careRecipient)),
                sendEmail: sendEmail,
                onSuccess: onRegisterSuccess,
                onFailure: (errorCode: string) => handleErrorCode(errorCode)
            })
        );
    }, [dispatch, handleErrorCode, onRegisterSuccess]);

    // レスポンス取得中
    if (!careRecipientList) return <Loading />;

    return (
        <>
            { processing && <FullScreenLoading/>}
            <div className={"user_edit_page"}>
                <div className={"container"}>
                    <BackButton />
                    <p className={"header"}>ユーザー登録</p>
                    <UserInfoEditComponent
                        editType={UserEditType.ADD}
                        userName={null}
                        userEmail={null}
                        userRole={null}
                        careRecipientList={careRecipientList}
                        whenSaveButtonClicked={handleRegisterClicked}
                    />
                </div>
            </div>
        </>
    );
}
